export default __webpack_public_path__ + "static/media/Transload.d12665f0.svg";